import { render, staticRenderFns } from "./tbzgfhxsc.vue?vue&type=template&id=6be76c3a&"
import script from "./tbzgfhxsc.vue?vue&type=script&lang=js&"
export * from "./tbzgfhxsc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports